import store from '../../../../store';

import Modal from '../../../../components/common/dialog/dialog.vue';
import VSelect from '../../../../components/common/select/select.vue';
import Lookup from '../../../../components/common/lookup/lookup.vue';

import { METADATA_TYPES } from '../../../../config';
import KeyboardHelper from '../../../../helpers/keyboard.helper';

import l10n from '../../../../transformers/l10n';

import includes from 'lodash/includes';
import map from 'lodash/map';


const ALL_KEYS_CODE = 0;
const ENTER_CODE = 13;

const OPTIONS = {
   showHeader: false,
   showFooter: false
};

export default {
   name: 'KeyDetectDialog',
   store,
   components: { Modal, VSelect, Lookup },
   data() {
      return {
         opts  : { ...OPTIONS, canConfirmChecker: () => this.isFinished },
         letter: '',
         letterCode: null,
         type : null,
         item : null,
         boundedCodes: []
      };
   },
   computed: {
      isBound() {
         return includes(this.boundedCodes, this.letterCode);
      },
      resolvedValue() {
         return { code: this.letterCode, item: this.item };
      },
      isFinished() {
         return !!this.item;
      },
      types() {
         return map(METADATA_TYPES, ({type, tk }) => {
            return { value: type, label: l10n(tk) };
         });
      },
      metadata() {
         return this.item ? [ this.item ] : [];
      }
   },
   methods: {
      onChangeType(type) {
         this.type = type;
      },
      onKeypressed(e) {
         if (e.key !== ' ' && e.key.toUpperCase() === String.fromCharCode(e.keyCode)) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            this.letter = e.key;
            this.letterCode = e.keyCode;
            this.type = null;
            this.item = null;
         }
      },
      async metadataLoader(q) {
         this.item = null;
         return await this.$options.metadataLoader(this.type, q);
      },
      changeMetadata([item]) {
         this.item = item;
      },
      confirmIfPossible() {
         this.$nextTick(() => {
            if (this.isFinished) {
               this.$emit('confirm');
            }
         });
      }
   },
   mounted() {
      this.boundedCodes = this.$options.boundedCodes;
      this.$nextTick(() => {
         this._listeners = [
            KeyboardHelper.keydown(this.onKeypressed, ALL_KEYS_CODE, { shareEvent: true, unshift: true }),
            KeyboardHelper.keydown(this.confirmIfPossible, ENTER_CODE, { stop: true, unshift: true, ignoreInput: false })
         ];
      });
   },
   beforeDestroy() {
      this._listeners.forEach(off => off());
      this._listeners.length = 0;
   }
};
